export default function SvgUsers(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            {...props}
        >
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M22 20.996v-2a4.002 4.002 0 00-3-3.874M15.5 3.286a4.001 4.001 0 010 7.419m1.5 10.29c0-1.863 0-2.795-.305-3.53a4 4 0 00-2.164-2.165c-.735-.304-1.667-.304-3.531-.304H8c-1.864 0-2.796 0-3.53.304a4 4 0 00-2.166 2.165C2 18.2 2 19.132 2 20.995m11.5-14a4 4 0 11-8 0 4 4 0 018 0z"
            ></path>
        </svg>
    )
}